//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      passShow: false,
      paswd: '',
      use: '',
      position: 'default',
      showPositionValue: false,
      tiptxt:'',
      tipType:'',
    }
  },
  methods: {
    loginSub() {
      let data = 'cmd=login&id_mobile='+this.use+'&password='+this.paswd;
      this.$http.post('https://api.abeiyun.com/www/login.php',data).then(({data}) => {
        this.showPosition('middle')
        this.tiptxt = data.msg;
        if(data.response==200){
          this.tipType ='success';
          setTimeout(() => {
            this.$router.push('/main');
          }, 2500);

        }else {
          this.tipType = 'warn';
        }

      })
    },
    showPosition (position) {
      this.position = position
      this.showPositionValue = true
    },
    changePassDisplay() {
      this.passShow = !this.passShow
    },
  },
  computed: {

  },
  components: {

  }
}



// WEBPACK FOOTER //
// ./src/components/user/login.vue